"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var ExportStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  DELETED: 'DELETED'
};
var _default = ExportStatus;
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(ExportStatus, "ExportStatus", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/export-status.js");
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/common/export-status.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJFeHBvcnRTdGF0dXMiLCJQRU5ESU5HIiwiUlVOTklORyIsIkNPTVBMRVRFRCIsIkZBSUxFRCIsIkRFTEVURUQiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tbW9uL2V4cG9ydC1zdGF0dXMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgRXhwb3J0U3RhdHVzID0ge1xuXHRQRU5ESU5HOiAnUEVORElORycsXG5cdFJVTk5JTkc6ICdSVU5OSU5HJyxcblx0Q09NUExFVEVEOiAnQ09NUExFVEVEJyxcblx0RkFJTEVEOiAnRkFJTEVEJyxcblx0REVMRVRFRDogJ0RFTEVURUQnLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgRXhwb3J0U3RhdHVzO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUEsSUFBTUEsWUFBWSxHQUFHO0VBQ3BCQyxPQUFPLEVBQUUsU0FBUztFQUNsQkMsT0FBTyxFQUFFLFNBQVM7RUFDbEJDLFNBQVMsRUFBRSxXQUFXO0VBQ3RCQyxNQUFNLEVBQUUsUUFBUTtFQUNoQkMsT0FBTyxFQUFFO0FBQ1YsQ0FBQztBQUFDLGVBRWFMLFlBQVk7QUFBQTtBQUFBO0FBQUE7QUFBQTtFQUFBO0VBQUE7SUFBQTtFQUFBO0VBQUEsd0JBUnJCQSxZQUFZO0VBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0FBQUEifQ==